class Webinar {
  constructor() {
    this.config = {
      webinarContainer: () => document.querySelectorAll('[data-module="Webinar"]'),
      webinarOption: el => el.querySelector('[data-module="Webinar__Option"]'),
      webinarDate: el => el.querySelector('[data-module="Webinar__Date"]')
    };
  }

  init() {
    this.config.webinarContainer().forEach(el => {
      const { data, optionText } = el.dataset;
      const jsonData = JSON.parse(data);
      const option = this.config.webinarOption(el);
      const date = this.config.webinarDate(el);

      if (!option || !date) {
        return;
      }

      option.addEventListener('change', e => {
        const { value } = e.target;
        const selectedWebinar = jsonData.find(webinar => webinar.name === value);

        if (!selectedWebinar) {
          return;
        }

        date.innerHTML = '';

        const choiceOption = document.createElement('option');
        choiceOption.value = '';
        choiceOption.innerHTML = optionText;
        choiceOption.disabled = true;
        choiceOption.selected = true;
        date.appendChild(choiceOption);

        selectedWebinar.dates.forEach(d => {
          const o = document.createElement('option');
          o.value = d;
          o.innerHTML = d;
          date.appendChild(o);
        });

        date.disabled = false;
      });
    });
  }
}

export default Webinar;
